<template>
  <!-- 相关推荐 -->
  <div class="recommend-box">
    <div class="header">推荐阅读</div>
    <div class="card-box">
      <template v-if="recommendList && recommendList.length">
        <router-link
          v-for="(item, index) in recommendList.slice(0, 10)"
          :key="index"
          :to="getJumpWikiDetailUrl(gameInfo.alias, gameInfo.id, item.id, true)"
          target="_blank"
        >
          <div :key="index" class="card-item">
            <div class="card-title">{{ item.title }}</div>
            <div class="des">{{ deleteHtmlStr(item.summary) }}</div>
            <div class="img-wrapper">
              <template v-for="(img, index) in item.thumb_list">
                <div v-if="img && index < 3" :key="index" class="img-item">
                  <img v-lazy="handleImgSize(img, 'small')" alt="" />
                  <div v-if="index == 2 && item.thumb_list.length > 3" class="mask">
                    +{{ item.thumb_list.length - 3 }}
                  </div>
                </div>
              </template>
            </div>
            <div class="user-line">
              <span class="user">
                <img v-lazy="handleImgSize(item.user.avatar, 'mini')" alt="" />
                <span class="name">{{ item.user.username }}</span>
              </span>
              <div class="info">
                <span style="margin-right: 13px;">
                  <img class="icon" src="@/assets/images/view-icon.svg" alt="" />
                  {{ formatCount(item.view_count) }}
                </span>
                <span>
                  <img class="icon" src="@/assets/images/like-icon.svg" alt="" />
                  {{ formatCount(item.like_count) }}
                </span>
              </div>
            </div>
          </div>
        </router-link>
      </template>
      <template v-else>
        <div class="empty-box">
          ~暂无相关推荐~
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getJumpWikiDetailUrl } from "@/plugins/util";

export default {
  name: "wikiCataLog",
  components: {},
  props: {
    recommendList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  data() {
    return {
      visible: false,
      cataList: [],
      scrollY: 0,
      calcCustomStyle: {}
    };
  },
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  methods: {
    getJumpWikiDetailUrl,
    // 服务端渲染，替代getContentText
    deleteHtmlStr(str = "") {
      return str.replace(/<[^>]*>/g, "");
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.recommend-box {
  padding-top: 35px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 29px;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    margin-bottom: 38px;
    &::after,
    &::before {
      content: "";
      display: block;
      width: 331px;
      height: 1px;
      background: #e3e3e3;
    }
  }
  .card-box {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 12px;
    .card-item {
      width: 260px;
      height: 190px;
      border-radius: 8px;
      border: 1px solid #e8e8e8;
      padding: 16px 22px 0 14px;
      cursor: pointer;
      .card-title {
        .ellipsis;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        margin-bottom: 4px;
      }
      .des {
        height: 34px;
        margin-bottom: 12px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 17px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .img-wrapper {
        display: flex;
        height: 60px;
        margin-bottom: 16px;
        .img-item {
          width: 60px;
          height: 60px;
          cursor: pointer;
          position: relative;
          border-radius: 4px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          & + .img-item {
            margin-left: 8px;
          }

          .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: fade(#000, 70%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 16px;
          }
        }
      }
      .user-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        overflow: hidden;
        .user {
          .ellipsis;
          display: flex;
          align-items: center;
          flex: 1;
          img {
            flex: 0 0 auto;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 8px;
            background-color: #e4e3e1;
          }
          .name {
            .ellipsis;
            flex: 1;
            margin-top: 2px;
            color: #666;
            font-size: 12px;
          }
        }
        .info {
          flex: 0 0 auto;
          color: #666;
          font-size: 12px;
          font-weight: 400;
          display: flex;
          align-items: center;
          > span {
            display: inline-flex;
            align-items: center;
            line-height: 16px;
          }
          .icon {
            width: 14px;
            height: 14px;
            margin-right: 2px;
          }
        }
      }
    }

    .empty-box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
    }
  }
}
</style>
